import React, { useMemo } from 'react';

import { Button } from '@gogame/components';
import { useGridApiContext } from '@gogame/data-grid';

import { useBatchRemove } from 'scenes/Gallery/GalleryPage/ConceptFamilies/data';
import { useGalleryPermissions } from 'scenes/Gallery/GalleryPage/hooks';

const BatchToolbar = ({ selectedRows }) => {
  const { isAllowManageConceptFamilies } = useGalleryPermissions();
  const [batchRemove] = useBatchRemove();

  const handleBatchDelete = async (selectedRows) => {
    await batchRemove(selectedRows);
  };

  if (!isAllowManageConceptFamilies) {
    return null;
  }
  return (
    <React.Fragment>
      <Button onClick={() => handleBatchDelete(selectedRows)}>Delete</Button>
    </React.Fragment>
  );
};

export default BatchToolbar;

export const BatchToolbarDataGrid = ({ selectedValues, ...props }) => {
  const {
    current: { getRow },
  } = useGridApiContext();

  const selectedRows = useMemo(() => {
    if (!getRow) {
      return selectedValues.map((id) => ({ id }));
    }

    return selectedValues.map((id) => {
      const { name } = getRow(id);

      return {
        id,
        name,
      };
    });
  }, [selectedValues, getRow]);

  return <BatchToolbar selectedRows={selectedRows} {...props} />;
};
